import { render, staticRenderFns } from "./Reminder.vue?vue&type=template&id=04b9c214&scoped=true"
import script from "./Reminder.vue?vue&type=script&lang=js"
export * from "./Reminder.vue?vue&type=script&lang=js"
import style0 from "./Reminder.vue?vue&type=style&index=0&id=04b9c214&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b9c214",
  null
  
)

export default component.exports